import React, { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import AsyncCreatableSelect from "react-select/async-creatable";
import { API } from "@aws-amplify/api";
import { listCoupons } from "graphql/queries";
import { Actions as ACTIONS } from "store/customer/action";
import { Actions as NOTIFICATIONACTIONS } from "store/notifications/action";

const CustomerCoupons = ({
  customer,
  coupons,
  businessID,
  saveCouponToCustomer,
  sendDeleteCustomerCoupon,
  addNotification,
  customerCoupons,
}) => {
  let history = useHistory();
  const [couponOption, setCouponOption] = useState({ value: "", label: "" });

  const selectDefaultStyle = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      border: "none",
    }),
  };

  const addCouponToCustomer = async () => {
    const customerCoupon = {
      couponID: couponOption.value,
      customerID: customer.id,
    };
    await saveCouponToCustomer(customerCoupon, couponOption.coupon);
    setCouponOption({ value: "", label: "" });
  };

  const revokeCoupon = async (id) => {
    await sendDeleteCustomerCoupon(id);
  };

  const validateSelectedCoupon = (coupon) => {
    const isCouponAlreadySelected = customer?.coupons?.items?.find(
      (item) => item.coupon?.id === coupon.value && !item._deleted
    );
    if (isCouponAlreadySelected) {
      addNotification(
        {
          title: (
            <React.Fragment>
              <strong>Warning</strong>{" "}
            </React.Fragment>
          ),
          message: `Coupon already added.`,
          icon: `warning`,
        },
        5000
      );
      return false;
    }
    return true;
  };

  return (
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col">
        <div className="-my-2 py-2 sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 ">
          <div className="align-middle inline-block min-w-full shadow sm:rounded-lg border-b border-gray-200">
            <table className="min-w-full">
              <thead>
                <tr>
                  <th
                    colSpan={2}
                    className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Coupons (Enter the name or coupon code)
                    <div className="flex">
                      <AsyncCreatableSelect
                        className="mt-1 block form-select w-full p-0 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                        styles={selectDefaultStyle}
                        value={couponOption}
                        onChange={(selected) => {
                          const isValid = validateSelectedCoupon(selected);
                          if (isValid) setCouponOption(selected);
                        }}
                        onCreateOption={() => {
                          history.push(`/coupons/new`);
                        }}
                        defaultOptions={coupons?.map((coupon) => ({
                          value: coupon.id,
                          label: `${coupon.name} (${coupon.code}) `,
                          coupon: coupon,
                        }))}
                        loadOptions={(inputValue, callback) => {
                          const variables = {
                            businessID,
                            filter: {
                              or: [
                                { code: { beginsWith: inputValue } },
                                { name: { beginsWith: inputValue } },
                              ],
                              and: { enabled: { eq: true } },
                            },
                          };
                          const request = API.graphql({
                            query: listCoupons,
                            variables,
                            authMode: "AMAZON_COGNITO_USER_POOLS",
                          });
                          request.then(({ data }) => {
                            const couponsList = data.listCoupons.items;
                            const options = couponsList?.map((coupon) => ({
                              value: coupon.id,
                              label: `${coupon.name} (${coupon.code}) `,
                              coupon: coupon,
                            }));
                            callback(options);
                          });
                        }}
                      />
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          addCouponToCustomer();
                        }}
                        className="ml-2 py-1 px-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500"
                      >
                        Add
                      </button>
                    </div>
                  </th>
                  {/* <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    One Time Use Coupons
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        addCouponToCustomer();
                      }}
                      className="ml-2 inline-flex  py-1 px-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500"
                    >
                      Add
                    </button>
                  </th> */}
                </tr>
              </thead>
              <tbody className="bg-white">
                {customerCoupons?.map((item, index) => (
                  <tr key={item.coupon?.code}>
                    <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                      {item.coupon?.name} ({item.coupon?.code})
                    </td>
                    <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                      <button
                        onClick={(e) => {
                          if (!item.bookingID) revokeCoupon(item?.id);
                        }}
                        style={{
                          cursor: !item.bookingID ? "pointer" : "not-allowed",
                          opacity: !item.bookingID ? 1 : 0.5,
                        }}
                        className="inline-flex py-1 px-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-500"
                      >
                        {item.bookingID ? "Used" : "Revoke"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const customerCoupons = state.customer?.item?.coupons?.items?.filter(
    (c) => !c._deleted
  );
  return {
    customer: state.customer.item,
    coupons: state.coupon?.list?.filter((c) => c.enabled && !c._deleted),
    businessID: state.businessID,
    customerCoupons,
  };
};

const mapDispatchToProps = (dispatch) => ({
  saveCouponToCustomer: (item, coupon) =>
    dispatch(ACTIONS.saveCouponToCustomer(item, coupon)),
  sendDeleteCustomerCoupon: (id) =>
    dispatch(ACTIONS.sendDeleteCustomerCoupon(id)),
  addNotification: (notification, removeAfter) =>
    dispatch(NOTIFICATIONACTIONS.addNotification(notification, removeAfter)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerCoupons);
